import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import reducers from './reducer';

const enhancer = composeWithDevTools(applyMiddleware(thunk));
const store = createStore(combineReducers(reducers), enhancer);

export default store;